<template>
    <div>
      <!-- Template remains mostly the same, just cleaned up -->
      <unicom-linha :espacamento="false">
        <unicom-coluna>
          <div class="conteudo-principal-container">
            <!-- Step navigation -->
            <unicom-linha :espacamento="false">
              <unicom-coluna>
                <unicom-step :abas="abas" @click="trocaStep" />
              </unicom-coluna>
            </unicom-linha>
  
            <!-- Tab content -->
            <unicom-linha :espacamento="false">
              <unicom-coluna>
                <div class="container-aba">
                  <DadosBasicos v-show="index === 0" v-model="dados" 
                    :isColaborador="isColaborador" :somenteVisualizar="somenteVisualizar" 
                    ref="dadosBasicos" @atualizar="$emit('atualizar')" />
                  
                  <DadosProfissionais v-if="index === 1" v-model="dados" 
                    :isColaborador="isColaborador" ref="dadosProfissionais" />
                  
                  <tabela-papeis v-if="index === 2" :idUsuario="dados.id"
                    :listaUnimeds="unimedsPorUsuario()" :somenteVisualizar="somenteVisualizar" />
                </div>
              </unicom-coluna>
            </unicom-linha>
  
            <!-- Footer buttons -->
            <unicom-linha espacamento class="linha-rodape" v-if="index !== 2">
              <unicom-coluna :md="2">
                <unicom-botao :tipo="'primario'" :contornado="true" bloco 
                  class="fonte-secundaria texto" @click="$emit('fechar')">
                  {{ somenteVisualizar ? "VOLTAR" : "CANCELAR" }}
                </unicom-botao>
              </unicom-coluna>
  
              <unicom-coluna :md="10" v-if="!somenteVisualizar">
                <unicom-linha :espacamento="true" :justificarItem="'end'">
                  <unicom-coluna :md="3">
                    <unicom-botao :tipo="'primario'" :bloco="true" 
                      class="fonte-secundaria texto" @click="salvar">
                      SALVAR ALTERAÇÕES
                    </unicom-botao>
                  </unicom-coluna>
                </unicom-linha>
              </unicom-coluna>
            </unicom-linha>
          </div>
        </unicom-coluna>
      </unicom-linha>
  
      <!-- Modals -->
      <unicom-modal-loading v-model="carregamento" />
      <unicom-modal :value="loading" :largura="320">
        <div slot="body">
          <unicom-loading v-model="loading" style="margin-top:25px;" :mensagem="mensagemLoading" />
        </div>
      </unicom-modal>
      <unicom-modal-sucesso v-model="modalSucesso" :titulo="mensagemSucesso" @fechar="fecharSucesso" />
      <ModalRemocaoPapeis v-model="apresentarModalRemocaoPapeis" :papeis="papeisRemovidos" @fechar="fecharModalRemocaoPapeis" />
    </div>
  </template>
  
  <script>
  import DadosBasicos from "./DadosBasicos";
  import DadosProfissionais from "./DadosProfissionais";
  import TabelaPapeis from "./TabelaPapeis";
  import ModalRemocaoPapeis from "./ModalRemocaoPapeis.vue";
  
  import PessoaJuridicaMixinService from "../services/PessoaJuridicaMixinService";
  import ColaboradorMixinService from "../../../../mixins/services/gerenciarUsuarios/ColaboradorServiceMixin";
  import UsuarioUnimedServiceMixin from "../../../../mixins/services/usuarioUnimed/UsuarioUnimedServiceMixin";
  import UsuarioServiceMixin from "../../../../mixins/services/usuario/UsuarioServiceMixin";
  
  export default {
    name: 'EditarUsuario',
    mixins: [PessoaJuridicaMixinService, ColaboradorMixinService, UsuarioServiceMixin, UsuarioUnimedServiceMixin],
    components: {
      DadosBasicos,
      DadosProfissionais,
      TabelaPapeis,
      ModalRemocaoPapeis
    },
    props: {
      dadosUsuario: {
        type: Object,
        default: () => ({
          conselhoProfissional: {
            estado: "",
            numeroConselho: 0,
            tipoConselhoProfissional: { codigo: 0, descricao: "" }
          },
          dataNascimento: "",
          documento: { numeroDocumento: "", tipoDocumento: { codigo: 0, descricao: "" } },
          email: "",
          genero: "",
          id: 0,
          login: {},
          nome: "",
          status: "",
          telefone: "",
          tipoColaborador: { codigo: 0, descricao: "" },
          unimeds: []
        })
      },
      isColaborador: { type: Boolean, required: true },
      somenteVisualizar: { type: Boolean, default: false }
    },
    data() {
      return {
        index: 0,
        dados: { ...this.dadosUsuario },
        abas: [
          { nome: "DADOS BÁSICOS", ativo: true, atual: true },
          { nome: "DADOS PROFISSIONAIS", ativo: true, atual: false },
          { nome: "APLICAÇÕES E PAPÉIS", ativo: true, atual: false }
        ],
        carregamento: false,
        mensagemLoading: "",
        loading: false,
        mensagemSucesso: "Os dados foram alterados com sucesso!",
        modalSucesso: false,
        papeisRemovidos: [],
        apresentarModalRemocaoPapeis: false
      };
    },
    methods: {
      unimedsPorUsuario() {
        const sessao = this.getSession();
        if (sessao.usuarioUnimed.perfil.id === -1) {
          return this.dados.unimeds;
        }
        
        const idUnimed = sessao.usuarioUnimed.unimed.id;
        return this.dados.unimeds.filter(item => item.unimed.id === idUnimed);
      },
      
      trocaStep(index) {
        this.abas[this.index].atual = false;
        this.index = index;
        this.abas[index].atual = true;
      },
      
      async salvar() {
        const isValid = await this.$refs.dadosBasicos.$refs.observer.validate();
        if (!isValid) return;
  
        this.loading = true;
        this.mensagemLoading = "Atualizando dados...";
  
        try {
          switch (this.index) {
            case 0: 
              await this.salvarDadosBasicos();
              break;
            case 1: 
              await this.salvarDadosProfissionais();
              break;
          }
        } catch (error) {
          console.error("Erro ao salvar dados:", error);
        } finally {
          this.loading = false;
        }
      },
      
      async salvarDadosBasicos() {
        const data = {
          idUsuario: this.dados.id,
          status: this.dados.status !== "INATIVA" ? this.dados.status : "INATIVO",
          telefone: this.dados.telefone.replace(/[^0-9]+/g, ""),
          email: this.dados.email,
          nomeCompleto: this.isColaborador ? this.dados.nome : this.dados.razaoSocial,
          dataNascimento: this.dados.dataNascimento,
          genero: this.dados.genero
        };
  
        await this.putAtualizarDadosBasicos(data);
        this.atualizarSessaoSeNecessario(data);
        this.mostrarSucesso("Alteração dos dados realizada com sucesso!");
      },
      
      async salvarDadosProfissionais() {

        this.atualizarIdsDasUnimeds();
        const dataEdicao = this.prepararDadosEdicaoUnimeds();
        
        const promises = [this.putUnimedUsuario(this.dados.id, dataEdicao)];
        
        if (this.isColaborador) {
          const dadosProfissionais = this.prepararDadosProfissionais();
          const promiseDadosProfissionais = this.putDadosProfissionais(this.dados.id, dadosProfissionais);
          promises.push(promiseDadosProfissionais);
          
          const responses = await Promise.all(promises);
          await this.processarRespostaDadosProfissionais(responses[1]);
        } else {
          await Promise.all(promises);
          this.mostrarSucesso("Alteração dos dados realizada com sucesso!");
        }
      },
      
      atualizarIdsDasUnimeds() {
        const storageUnimeds = JSON.parse(localStorage.getItem("unimeds"));
        
        this.dados.unimeds.forEach(el => {
          if (!el.unimed.codigo) {
            const uni = this.$refs.dadosProfissionais.listaUnimeds.find(
              it => it.codigoNome == el.unimed.codigoNome
            );
            el.unimed.id = uni?.codigo;
          } else {
            const uni = storageUnimeds.find(it => it.codigo == el.unimed.codigo);
            el.unimed.id = uni?.codigo;
          }
        });
      },
      
      prepararDadosEdicaoUnimeds() {
        return this.dados.unimeds.map(el => ({
          codigo: el.unimed.id,
          idPerfil: el.perfil.id === -1 ? 1 : el.perfil.id,
          idUsuario: this.dados.id
        }));
      },
      
      prepararDadosProfissionais() {
        return {
          conselhoProfissional: {
            numeroConselho: this.dados.conselhoProfissional.numeroConselho,
            siglaEstado: this.dados.conselhoProfissional.estado,
            tipoConselho: this.dados.conselhoProfissional.tipoConselhoProfissional.descricao
          },
          tipoColaborador: this.dados.tipoColaborador.descricao
        };
      },
      
      async processarRespostaDadosProfissionais(response) {
        const papeisRemovidos = response.data?.papeisRemovidos || [];
        
        if (papeisRemovidos.length > 0) {
          const papeisRemovidosNoBackend = await this.removerPapeisNoBackend(papeisRemovidos);
          
          if (papeisRemovidosNoBackend.length > 0) {
            this.papeisRemovidos = papeisRemovidosNoBackend;
            this.apresentarModalRemocaoPapeis = true;
            return;
          }
        }
        
        this.mostrarSucesso("Alteração dos dados realizada com sucesso!");
      },
      
      async removerPapeisNoBackend(papeis) {
        const resultados = await Promise.all(
          papeis.map(papel => 
            this.deleteRemoverPapel(papel)
              .then(response => response.status === 200 ? papel : null)
              .catch(() => null)
          )
        );
        
        return resultados.filter(Boolean);
      },
      
      atualizarSessaoSeNecessario(data) {
        const usuarioSessao = this.getSession();
        if (usuarioSessao.userId === data.idUsuario) {
          usuarioSessao.email = data.email;
          localStorage.setItem("session", JSON.stringify(usuarioSessao));
          this.$emit("atualizar");
        }
      },
      
      mostrarSucesso(mensagem) {
        this.mensagemSucesso = mensagem;
        this.modalSucesso = true;
      },
      
      fecharSucesso() {
        this.modalSucesso = false;
        this.$emit("fechar");
      },
      
      fecharModalRemocaoPapeis() {
        this.apresentarModalRemocaoPapeis = false;
        this.mostrarSucesso("Alteração dos dados realizada com sucesso!");
      }
    }
  };
  </script>
  
  <style lang="scss" scoped>
  /* Styles remain the same */
  .conteudo-principal-container {
    margin-top: 24px;
    box-sizing: border-box;
    background-color: #fff;
    border-radius: 20px;
    padding-bottom: 35px;
  
    & .container-aba {
      box-sizing: border-box;
      width: 100%;
      min-height: 400px;
      padding: 24px 32px;
    }
  
    .linha-rodape {
      padding: 0 24px;
    }
  }
  </style>